module.exports = __webpack_public_path__ + "static/media/scene-element-banner.9f66bab8.png";